module.exports = __webpack_public_path__ + "img/icon-instagram.31a5d9a9.svg";